export { default } from './SurgicalHistoryDetailsPopup';
